import { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ClientLogos from "./components/ClientLogos";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Process from "./components/Process";
import Packs from "./components/Packs";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";
import SplashScreen from "./components/SplashScreen";
import PromoPopup from "./components/PromoPopup";
import CookieConsent from "./components/CookieConsent";
import VideoImmobilier from "./components/pages/VideoImmobilier";
import PhotoImmobilier from "./components/pages/PhotoImmobilier";
import DroneFpvImmobilier from "./components/pages/DroneFpvImmobilier";
import { LangProvider, useLang } from "./components/LangContext";
import { motion, AnimatePresence } from "framer-motion";

function HomePage() {
  const { lang } = useLang();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={lang}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <Navbar />
        <Hero />
        <ClientLogos />
        <About />
        <Services />
        <Portfolio />
        <Process />
        <Packs />
        <FAQ />
        <Contact />
        <Footer />
        <FloatingContact />
        <PromoPopup />
        <CookieConsent />
      </motion.div>
    </AnimatePresence>
  );
}

function ScrollToHash() {
  const { hash } = useLocation();
  if (hash) {
    setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }
  return null;
}

function App() {
  const isPrerendering = typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap');
  const [showSplash, setShowSplash] = useState(!isPrerendering);
  const handleSplashComplete = useCallback(() => setShowSplash(false), []);

  return (
    <BrowserRouter>
      <HelmetProvider>
        <LangProvider>
          <div className="App">
            {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
            <ScrollToHash />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/video-immobilier" element={<VideoImmobilier />} />
              <Route path="/photo-immobilier" element={<PhotoImmobilier />} />
              <Route path="/drone-fpv-immobilier" element={<DroneFpvImmobilier />} />
            </Routes>
          </div>
        </LangProvider>
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;
